import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "action-bar__item action-bar__button" }

import { WButton, WTooltip } from '@alice-health/wonderland-vue'
import { computed, onMounted, ref, watch } from 'vue'

import { MENU_TYPE } from '@/models/menu'
import { compareVersion } from '@/utils/version'
import Logger, { EventName } from '@/wrappers/logger'

import pkg from '../../../../package.json'

const updateAppTooltip =
  'Clique aqui para recarregar a página<br />e atualizar o app!&nbsp &#10024;<br /><br />ATENÇÃO: Conclua suas tarefas antes de<br />atualizar para evitar perda de dados!'

export default /*#__PURE__*/_defineComponent({
  __name: 'UpdateApp',
  props: {
  featureFlagVersion: {
    type: String,
    default: null
  }
},
  setup(__props) {

const props = __props;



const showStaticTooltip = ref(false)

const displayUpdateIcon = computed(() => {
  const currentVersion = pkg.version

  if (!props.featureFlagVersion) {
    return false
  }
  return compareVersion(currentVersion, props.featureFlagVersion) === -1
})

onMounted(() => {
  if (displayUpdateIcon.value) {
    setTimeout(() => openUpdateTooltip(), 2000)
  }
})

watch(displayUpdateIcon, value => {
  if (value) openUpdateTooltip()
})

const reloadPage = () => {
  Logger.addLog(EventName.USER_INTERACTION_MENU, {
    data: {
      context: MENU_TYPE.REALOD
    }
  })
  window.location.reload()
}

const openUpdateTooltip = () => {
  showStaticTooltip.value = true
  setTimeout(() => (showStaticTooltip.value = false), 5000)
}

return (_ctx: any,_cache: any) => {
  return (displayUpdateIcon.value)
    ? (_openBlock(), _createBlock(_unref(WTooltip), {
        key: 0,
        label: updateAppTooltip,
        static: showStaticTooltip.value,
        position: "right"
      }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_1, [
            _createVNode(_unref(WButton), {
              icon: "icUpdate",
              size: "large",
              "icon-button": "",
              onClick: reloadPage
            })
          ])
        ]),
        _: 1
      }, 8, ["static"]))
    : _createCommentVNode("", true)
}
}

})